import React, { Component } from 'react';
import { NavDropdown } from 'react-bootstrap';
class NavDropdownCustom extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    };
  }

  handleOpen = () => {
    if (this.props.disableMouseOver) return; //mobile view
   // console.log('handle Open');
    this.onToggleHandler(true);
  };

  handleClose = () => {
    if (this.props.disableMouseOver) return; //mobile view
   // console.log('handle Close');
    this.onToggleHandler(false);
  };

  onToggleHandler = (e) => {
   // console.log('toggle');
    this.setState({ isOpen: e, openClick: !this.state.onClick });
  };

  render() {
    
    const { disableMouseOver, ...rest } = this.props;

    return (
      <NavDropdown
        {...rest}
        onMouseEnter={this.handleOpen}
        onMouseLeave={this.handleClose}
        onToggle={this.onToggleHandler}
        onSelect={this.props.onSelect}
        open={this.state.isOpen || (disableMouseOver && this.props.comp === 'menu')}
        defaultOpen={false}
      >
        {this.props.children}
      </NavDropdown>
    );
  }
}

export default NavDropdownCustom;
